import AiAssist from './AiAssist';

export default AiAssist;
